
import SelectProductQty from '../../form/multi-pickup/SelectProductQtyMulti.js';

function PanelSelectProductQtyMulti(props) {

  const isPistachioEvent = props.isPistachioEvent ?? false;

   return (
    <div className="step">
        <p>步驟3：選擇預購指定數量(必填)</p>
        <SelectProductQty item_Details={props.item_Details} setItemQty={(Item_Code, value)=>props.setItemQty(Item_Code, value)} totalAmount={props.totalAmount} isShowScanInput={props.isShowScanInput} passClearSelectedItems={props.passClearSelectedItems}></SelectProductQty>
        {
            isPistachioEvent
            &&
            <span>
            <p className="warning" style={{backgroundColor: 'yellow', fontWeight: 'bold' }}>*香港包裝及內地包裝的原料同為美國開心果，僅包裝地不同，風味無異。預購成功後隨機發貨，不設揀貨。</p>
            </span>
            
        }
        <p className="warning">**一經成功付款，恕不能更改數量選擇</p>
    </div>
   );
 }
 
export default PanelSelectProductQtyMulti;